import LockIcon from '@assets/icons/lock.svg';
import { BODY_SM_SM_MEDIUM_STYLES, BodyXsXs } from '@constants/text.ts';
import { SharedPageWrapper } from '@routes/___shared___/styled.tsx';
import styled from 'styled-components';

export const TabItem = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: var(--spacing-xs, 8px);
`;

export const LearningCarousels = styled.div`
    display: flex;
    width: 100%;
    max-width: 1124px;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-sm, 16px);
    margin-bottom: 16px;
    overflow: hidden;
`;
export const LearningCarouselHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-self: stretch;
`;
export const Frame = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 4px;
`;
export const Arrows = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 7px;
    margin-left: auto;
    div {
        cursor: pointer;
    }

    .ant-btn-icon {
        margin-top: 6px;
    }
    .ant-btn:focus,
    .ant-btn:focus-visible,
    .ant-btn:active,
    .ant-btn:focus:not(:focus-visible) {
        outline: none !important;
        box-shadow: none !important;
    }
`;
export const FrameHeader = styled.div`
    display: flex;
    align-items: center;
    gap: var(--spacing-xs, 8px);
`;

export const LockIconWrapper = styled(LockIcon)`
    width: 14px;
    height: 18px;
`;

export const FrameHeaderText = styled.div`
    color: var(--colors-text-headings, #3e445c);
    font-family: var(--type-font-family, Poppins), serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: var(--line-height-heading-xs, 26px); /* 130% */
`;

export const RotateSvg = styled.div`
    svg {
        transform: rotate(180deg);
    }
`;

export const NextBtnIconWrapper = styled.div``;

export const LearningCarouselItems = styled.div`
    align-items: center;
    align-self: stretch;
    position: relative;
    z-index: 0;
`;

export const CarouselCard = styled.div`
    display: flex;
    padding-bottom: var(--spacing-md, 24px);
    flex-direction: column;
    align-items: center;
    gap: var(--spacing-sm, 16px);
    border-radius: var(--border-radius-s_8, 8px);
    border: 1px solid var(--colors-border-default, #b4b8bf);
    background: var(--neutral-white, #fff);
    max-width: 361px;
    height: 521px;
`;

export const CarouselImageInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--spacing-2xs, 4px);
    align-self: stretch;
    position: relative;
    overflow: hidden;
    border-radius: var(--border-radius-s_8, 8px);
`;

interface ProgressProps {
    $isCompleted: boolean;
}
export const CarouselProgressInfo = styled.div`
    display: flex;
    height: 112px;
    padding: 0px var(--spacing-md, 24px);
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    gap: var(--spacing-sm, 16px);
    align-self: stretch;
`;

export const CreatorAndProggress = styled.div<ProgressProps>`
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    align-content: flex-end;
    gap: 8px var(--spacing-xs, 8px);
    align-self: stretch;

    [type='button'] {
        ${BODY_SM_SM_MEDIUM_STYLES};
        width: 156px;
    }
    .ant-btn-icon {
        margin-top: 6px;
    }
`;

export const CardImage = styled.img`
    display: flex;
    height: 249px;
    flex-direction: column;
    align-items: flex-end;
    gap: var(--spacing-xs, 8px);
    align-self: stretch;
    aspect-ratio: 361/249;
    width: 361px;
`;

export const LockedContentNoItemsWrapper = styled.div`
    position: relative;
    height: 521px;
    width: inherit;
`;

export const OverdueCounter = styled.div`
    display: flex;
    height: 20px;
    width: 20px;
    padding: 0px 6px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 16px;
    background: var(--colors-icons-error, #da1e28);
    ${BodyXsXs} {
        color: #fff;
    }
`;

export const LearningPageWrapper = styled(SharedPageWrapper)`
    max-width: 74rem;
    padding-left: 0;
    padding-right: 0;

    .ant-tabs-tab:not(:first-child) {
        margin: 0 0 0 20px;
    }
`;

export const GlobalLearningSearchWrapper = styled.div`
    width: 394px;
    max-width: 100%;
    margin: 24px 0 32px;
`;
